import React, { ComponentType } from 'react'
import { CustomPageAction, fetchCustomSettings } from 'store/ducks/custompages'
import { Matching, connect } from 'react-redux'
import { GlobalState } from 'store/ducks/state'
import { buildImageFromId, extractSlug } from 'utils/customPage'
import { CustomPage } from 'interfaces/custompage'
import ds from 'views/styles/designSystem'

const mapStateToProps = (state: GlobalState) => ({
  customSettings: state.customPage.customSettings,
  loading: state.customPage.loading,
})

const mapDispatchToProps = (dispatch) => ({
  fetchCustomSettings: (slug: string) => {
    dispatch(fetchCustomSettings(slug))
  },
})

export interface CustomPageContextProps {
  customColor: string | undefined
  customBgColor: string | undefined
  isCustomPage: boolean
  customCompanyName: string | undefined
  backgroundImageUrl: string | undefined
  customLogo: string | undefined
  customSlug: string | undefined
  loading: boolean
}

export const CustomPageContext = React.createContext<CustomPageContextProps>({
  customColor: undefined,
  customBgColor: undefined,
  customCompanyName: undefined,
  backgroundImageUrl: undefined,
  customLogo: undefined,
  customSlug: undefined,
  isCustomPage: false,
  loading: false,
})

type WrappedContextProps = {
  fetchCustomSettings: (slug: string) => CustomPageAction
  customSettings: CustomPage
  loading: boolean
}

const WrappedContext: React.FC<WrappedContextProps> = ({ fetchCustomSettings, customSettings, loading, ...props }) => {
  const slug = extractSlug()

  React.useEffect(() => {
    fetchCustomSettings(slug)
  }, [fetchCustomSettings, slug])

  return (
    <CustomPageContext.Provider
      value={{
        customColor: customSettings?.buttonColor ?? ds.brand('magneticBlack'),
        customBgColor: customSettings?.backgroundColor ?? ds.brand('white'),
        backgroundImageUrl: buildImageFromId(customSettings?.backgroundImageUrl),
        customLogo: buildImageFromId(customSettings?.logoUrl),
        isCustomPage: true,
        customCompanyName: slug,
        customSlug: slug,
        loading,
      }}
      {...props}
    />
  )
}

export const CustomPageContextProvider = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  (WrappedContext as unknown) as ComponentType<
    Matching<
      { customSettings: CustomPage; loading: boolean } & { fetchCustomSettings: (slug: string) => void },
      WrappedContextProps
    >
  >,
)

export const useCustomPageContext = () => React.useContext(CustomPageContext)
